export const FEEDBACK_TYPE = {
  CONTACTS: "CONTACTS",
  ENTERPRISE: "ENTERPRISE"
}
